enum ReportType {
	AllTransactions = 'All Transactions',
	Usages = 'Usage',
	SalesByCard = 'Sales By Cards',
	SalesByLocations = 'Sales By Locations',
}

export default ReportType;
